import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDocumentTitle = (title: string) => {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    let pageTitle = '';

    switch (path) {
      case '/':
      case '/login':
        pageTitle = 'Login Dashboard';
        break;
      case '/dashboard':
        pageTitle = 'Dashboard Top Management';
        break;
      default:
        pageTitle = title || path.split('/').filter(Boolean).pop() || '';
    }

    document.title = pageTitle;
  }, [title, location]);
};